<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminSeckill.queryCondition') }}</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input :placeholder="$t('adminSeckill.inputProductName')"
                v-model="adminSeckillInfo.conditions.prodName" clearable></el-input>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="_queryProductMethod">
                {{ $t('adminSeckill.query') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminSeckill.shopSeckill') }}</span>
          </div>
          <el-table :data="adminSeckillInfo.productSeckills" border style="width: 100%">
            <el-table-column prop="prodName" :label="$t('aShopDetailSeckill.productName')"
              align="center"></el-table-column>
            <el-table-column prop="killHours" :label="$t('aShopDetailSeckill.killHours')"
              align="center"></el-table-column>
            <el-table-column prop="continueHours" :label="$t('aShopDetailSeckill.continueHours')"
              align="center"></el-table-column>
            <el-table-column prop="totalCount" :label="$t('aShopDetailSeckill.totalCount')"
              align="center"></el-table-column>
            <el-table-column prop="oneCount" :label="$t('aShopDetailSeckill.oneCount')"
              align="center"></el-table-column>
            <el-table-column prop="killPrice" :label="$t('aShopDetailSeckill.killPrice')" align="center">
              <template slot-scope="scope">
                ￥{{ scope.row.killPrice }}
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('aShopDetailSeckill.price')" align="center">
              <template slot-scope="scope">
                ￥{{ scope.row.price }}
              </template>
            </el-table-column>
            <el-table-column prop="killStock" :label="$t('aShopDetailSeckill.killStock')"
              align="center"></el-table-column>
            <el-table-column prop="state" :label="$t('aShopDetailSeckill.state')" align="center">
              <template slot-scope="scope">
                {{ scope.row.state == '1001' ? $t('aShopDetailSeckill.open') : $t('aShopDetailSeckill.close') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('aShopDetailSeckill.validity')" align="center">
              <template slot-scope="scope">
                {{ scope.row.startTime }}~{{ scope.row.endTime }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="adminSeckillInfo.conditions.page"
            :page-size="adminSeckillInfo.conditions.row" layout="total, prev, pager, next"
            :total="adminSeckillInfo.total" class="pagination"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct"></delete-product>
  </div>
</template>

<script>
import { listAdminSeckill } from '@/api/group/adminSeckillApi'
import AdminShop from '@/components/shop/adminShop'
import DeleteProduct from '@/components/admin/deleteProduct/deleteProduct'

export default {
  name: 'AdminSeckill',
  components: {
    AdminShop,
    DeleteProduct
  },
  data() {
    return {
      adminSeckillInfo: {
        productSeckills: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          prodName: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this._listAdminSeckills()
  },
  methods: {
    handleShopChange(shop) {
      this.adminSeckillInfo.conditions.shopId = shop.shopId
      this._listAdminSeckills()
    },
    handleCurrentChange(currentPage) {
      this.adminSeckillInfo.conditions.page = currentPage
      this._listAdminSeckills()
    },
    async _listAdminSeckills() {
      try {
        const res = await listAdminSeckill(this.adminSeckillInfo.conditions)
        this.adminSeckillInfo.productSeckills = res.data
        this.adminSeckillInfo.total = res.total
      } catch (error) {
        console.error('获取秒杀列表失败:', error)
      }
    },
    _queryProductMethod() {
      this.adminSeckillInfo.conditions.page = 1
      this._listAdminSeckills()
    },
    _openDeleteProductModel(product) {
      console.log(product)
      this.$refs.deleteProduct.open(product)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.margin-top {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>